/* @ngInject */
export default function ($translate) {
  const pluralPattern = /^\{PLURALIZE,\s*plural,\s*one\{([\s\S]*?)\}\s*other\{([\s\S]*?)\}\s*\}$/;

  return (translationId, count, interpolationParams) => {
    if (!translationId) return translationId;

    const numericCount = Number(count);
    const translated = $translate.instant(translationId, interpolationParams || {});
    const match = pluralPattern.exec(translated);

    if (!match) return translated;

    const oneCase = match[1];
    const otherCase = match[2];
    const resolved = numericCount === 1 ? oneCase : otherCase;

    return resolved.replace(/#/g, numericCount);
  };
}
